<template>
  <ul class="sidebar-controls">
    <li class="sidebar-controls__item" @click="onClick('report')">
      Отчеты
    </li>
    <li class="sidebar-controls__item" @click="onClick('picture')">
      Картина дня
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Controls',
  methods: {
    onClick(to) {
      this.$emit('onSideBarToggle');
      this.$router.push(`/thread-id-${this.$route.params.id}/${to}`);
    }
  },
};
</script>

<style>
@import "css/style.css";
</style>
